<template>
  <div class="order-allocation-details">
    <basic-container>
      <!-- 搜索栏 -->
      <OrderSearch 
        :searchForm="searchForm"
        @search="handleSearch"
        @export="exportList"
        @rerun="openRerunDialog"
        @viewHistory="openHistoryDialog"
        :loadingExporth="loadingExporth"
        :businessTypeOptions="businessTypeOptions"
        :paymentMethodOptions="paymentMethodOptions"
        :purchaseSourceOptions="purchaseSourceOptions"
        :clientTypesOptions="clientTypesOptions"
        :memberTypeOptions="memberTypeOptions"
        :goodsNameOptions="goodsNameOptions"
      />

      <!-- 列表 -->
      <div class="table-container">
        <OrderTable
          :tableData="tableData"
          :loading="loading"
        />

        <!-- 分页 -->
        <div class="pagination-container">
          <ElementPagination
            :current-page="page.current"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="page.size"
            :total="page.total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </basic-container>

    <!-- 重跑收入/成本确认数据 弹窗 -->
    <el-dialog
      title="重跑收入/成本确认数据"
      :visible.sync="rerunDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form :model="rerunForm" :rules="rerunRules" ref="rerunForm" label-width="100px">
        <el-form-item label="开始月份" prop="startMonth">
          <el-date-picker
            v-model="rerunForm.startMonth"
            type="month"
            placeholder="请选择开始月份"
            format="yyyyMM"
            value-format="yyyyMM"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="结束月份" prop="endMonth">
          <el-date-picker
            v-model="rerunForm.endMonth"
            type="month"
            placeholder="请选择结束月份"
            format="yyyyMM"
            value-format="yyyyMM"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="订单ID">
          <el-input
            v-model="rerunForm.orderId"
            placeholder="可选，填写则只重跑该订单"
            clearable
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rerunDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="rerunLoading" @click="submitRerun">确认重跑</el-button>
      </div>
    </el-dialog>

    <!-- 查看重跑历史 弹窗 -->
    <el-dialog
      title="重跑历史记录"
      :visible.sync="historyDialogVisible"
      width="800px"
      append-to-body
      @opened="loadHistory"
      @close="handleHistoryClose"
    >
      <div style="margin-bottom: 10px; text-align: right;">
        <el-button
          type="text"
          icon="el-icon-refresh"
          :loading="historyLoading"
          @click="loadHistory"
        >刷新</el-button>
      </div>
      <el-table :data="historyList" v-loading="historyLoading" border stripe>
        <el-table-column prop="month" label="月份" width="120" />
        <el-table-column prop="requestTime" label="触发时间" width="180" />
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="{ row }">
            <el-tag :type="getStatusTagType(row.status)" size="small">{{ row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="finishTime" label="结束时间" width="180">
          <template slot-scope="{ row }">
            {{ row.finishTime || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="orderId" label="订单ID" min-width="180">
          <template slot-scope="{ row }">
            {{ row.orderId || '全量统计' }}
          </template>
        </el-table-column>
        <el-table-column prop="errorMsg" label="错误信息" min-width="200">
          <template slot-scope="{ row }">
            <span v-if="row.errorMsg" style="color: #f56c6c;">{{ row.errorMsg }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import OrderSearch from './components/search.vue'
import OrderTable from './components/table.vue'
import ElementPagination from '@/components/ElementPagination'
import moment from 'moment'
import {
  getBusinessTypeOptions,
  getPaymentMethodOptions,
  getPurchaseSourceOptions,
  getOrderAllocationList,
  getLeboMemberTypeOptions,
  getLeboGoodsTypeOptions,
  exportOrderAllocationList,
  runForOperation,
  getTaskStatus
} from '@/api/financialManage/orderAllocationDetails'
import {
  getMemberLeftOnlineList
} from '@/api/memberNew/memberType'
import {
  goodsPageApi
} from '@/api/goods_manage'

export default {
  name: 'OrderAllocationDetails',
  components: {
    OrderSearch,
    OrderTable,
    ElementPagination
  },
  data() {
    return {
      loadingExporth: false,
      // 重跑弹窗
      rerunDialogVisible: false,
      rerunLoading: false,
      rerunForm: {
        startMonth: '',
        endMonth: '',
        orderId: ''
      },
      rerunRules: {
        startMonth: [{ required: true, message: '请选择开始月份', trigger: 'change' }],
        endMonth: [{ required: true, message: '请选择结束月份', trigger: 'change' }]
      },
      // 重跑历史弹窗
      historyDialogVisible: false,
      historyLoading: false,
      historyList: [],
      pollingTimer: null,
      // 搜索表单
      searchForm: {
        month: '', 
        orderInfo: '',
        businessType: [],
        paymentMethod: [],
        purchaseSource: [],
        channel: [],
        memberType: [],
        goodsIds: [],
        orderTypes: ''
      },
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 分页信息
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      businessTypeOptions: [],
      paymentMethodOptions: [],
      purchaseSourceOptions: [],
      clientTypesOptions: [],
      memberTypeOptions: [],
      goodsNameOptions: []
    }
  },
  created() {
    this.searchForm.month = moment().subtract(1, 'month').format('YYYY-MM')
    this.getTableData()
    this.getBusinessTypeOptions()
    this.getPaymentMethodOptions()
    this.getPurchaseSourceOptions()
    this.getMemberTypeOptions()
    this.getGoodsTypeOptions()
  },
  beforeDestroy() {
    this.stopPolling()
  },
  methods: {
    // 获取表格数据
    async getTableData() {
      this.loading = true
      try {
        const params = {
          monthStr: this.searchForm.month,
          searchStr: this.searchForm.orderInfo,
          busiTypes: this.searchForm.businessType.join(','),
          payTypes: this.searchForm.paymentMethod.join(','),
          buySources: this.searchForm.purchaseSource.join(','),
          appids: this.searchForm.channel.join(','),
          memberTypes: this.getMemberTypeId(this.searchForm.memberType),
          goodsTypes: this.getGoodsTypeId(this.searchForm.goodsIds),
          orderTypes: this.searchForm.orderTypes,
          current: this.page.current,
          size: this.page.size,
        }

        console.log('查询参数:', params)

        const { data } = await getOrderAllocationList(params)
        if (data.code === 200) {
          this.tableData = data.data.records.map(item => {
            return {
              ...item,
              paymentMethod: item.payType,
              purchaseSource: item.buySourceName,
              businessType: item.bussiSource,
              // 预处理标签字段，避免表格渲染时频繁计算
              businessTypeLabel: this.resolveOptionLabel(item.bussiSource, this.businessTypeOptions),
              paymentMethodLabel: this.resolveOptionLabel(item.payType, this.paymentMethodOptions),
              channelSource: `[${item.appid}]${item.channelName}`,
              memberType: item.mtypeName,
              goodsName: item.proName,
              purchaseDuration: item.buyTimeDesc,
              orderStatus: item.statusStr || '',
              orderNum: item.orderId,
              orderTime: item.createOrderTime,
              refundTime: item.refundTime,
              effectiveTime: item.startTime,
              expireTime: item.expireTime,
              orderAmount: item.totalAmount,
              refundAmount: item.refundAmount,
              availableDays: item.totalDays,
              usedDays: item.useDays,
              remainingDays: item.leftDays,
              dailyConsumeAmount: item.everyDayAmount,
              totalConfirmedIncome: item.totalConfirmAmount,
              periodConfirmedIncome: item.thisTermAmount,
              pendingConfirmedIncome: item.leftAmount,
              channelName: item.partnerName,
              channelCost: item.channelCost,
              channelRefundCost: item.refundCost,
              dailyConfirmedCost: item.dailyCost,
              totalConfirmedCost: item.totalCost,
              periodConfirmedCost: item.periodCost,
              pendingConfirmedCost: item.pendingCost,
              orderTypeText: item.orderType === 0 ? 'saas订单' : 'open订单',
            }
          })
          this.page.total = data.data.total
          this.loading = false
        }
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败')
        this.loading = false
      }
    },
    // 搜索
    handleSearch(params) {
      this.searchForm = { ...params }
      this.page.current = 1
      this.getTableData()
    },
    // 导出Excel
    async exportList() {
      console.log('导出列表')
      try {
        await this.$confirm('确认导出列表吗？', '提示', {
          type: 'warning'
        })

        const params = {
          monthStr: this.searchForm.month,
          searchStr: this.searchForm.orderInfo,
          busiTypes: this.searchForm.businessType.join(','),
          payTypes: this.searchForm.paymentMethod.join(','),
          buySources: this.searchForm.purchaseSource.join(','),
          appids: this.searchForm.channel.join(','),
          memberTypes: this.getMemberTypeId(this.searchForm.memberType),
          goodsTypes: this.getGoodsTypeId(this.searchForm.goodsIds),
          orderTypes: this.searchForm.orderTypes,
        }

        const { data } = await exportOrderAllocationList(params)
        
        if (data) {
          const blob = new Blob([data])
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = '订单分摊明细表_' + moment().format('YYYY-MM-DD') + '.xlsx'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(url)
          this.$message.success('导出成功')
        }
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败')
      }
    },
    // 分页大小改变
    handleSizeChange(size) {
      this.page.size = size
      this.getTableData()
    },
    // 当前页改变
    handleCurrentChange(current) {
      this.page.current = current
      this.getTableData()
    },
    // 获取业务类型
    async getBusinessTypeOptions() {
      try {
        const { data } = await getBusinessTypeOptions()
        if (data.code === 200) {
          this.businessTypeOptions = data.data.map((item) => {
            return {
              value: item.dictKey,
              label: item.dictValue,
            }
          })
        } 
      } catch (error) {
        console.error('获取业务类型失败:', error)
        this.$message.error('获取业务类型失败')
      }
    },
    // 获取支付方式
    async getPaymentMethodOptions() {
      try {
        const { data } = await getPaymentMethodOptions()
        if (data.code === 200) {
          this.paymentMethodOptions = data.data.map((item) => {
            return {
              value: item.dictKey,
              label: item.dictValue,
            }
          })
        }
      } catch (error) {
        console.error('获取支付方式失败:', error)
        this.$message.error('获取支付方式失败')
      }
      
    },
    // 获取购买来源
    async getPurchaseSourceOptions() {
      try {
        const { data } = await getPurchaseSourceOptions()
        console.log('获取购买来源:', data)
        if (data.code === 200) {
          this.purchaseSourceOptions = data.data.length > 0 ? data.data[0].children.map((item) => {
            return {
              value: item.dictKey,
              label: item.dictValue,
            }
          }) : []
        }
      } catch (error) {
        console.error('获取购买来源失败:', error)
        this.$message.error('获取购买来源失败')
      }      
    },
    // 获取会员类型
    async getMemberTypeOptions() {
      Promise.all([
        getMemberLeftOnlineList({
          current: 1,
          size: 999,
        }),
        getLeboMemberTypeOptions()
      ]).then((res) => {
        console.log('获取会员类型和商品类型:', res)
        const memberTypeOptions = res[0].data.data.records.map((item) => {
          return {
            id: item.id,
            label: `(${item.id}) ${item.name}`,
          }
        })

        const leboMemberTypeOptions = res[1].data.data.map((item) => {
          return {
            id: item.id,
            label: `(${item.id}) ${item.typeName}[旧]`,
          }
        })

        // 业务需要，将会员类型和商品类型合并，前端将两个数据合并后，再将index作为value
        this.memberTypeOptions = [...memberTypeOptions, ...leboMemberTypeOptions].map((item, index) => {
          return {
            ...item,
            value: index,
          }
        })
      }).catch((err) => {
        console.error('获取会员类型失败:', err)
        this.$message.error('获取会员类型失败')
      })
    },
    // 获取商品类型
    async getGoodsTypeOptions() {
      Promise.all([
        goodsPageApi({
          current: 1,
          size: 999,
        }),
        getLeboGoodsTypeOptions(),
      ]).then((res) => {
        console.log('获取商品类型:', res)
        const goodsPageOptions = res[0].data.data.records.map((item) => {
          return {
            id: item.id,
            label: `(${item.id}) ${item.goodsName}`,
          }
        })

        const goodsTypeOptions = res[1].data.data.map((item) => {
          return {
            id: item.id,
            label: `(${item.id}) ${item.goodsName}[旧]`,
          }
        })

        // 业务需要，将会员类型和商品类型合并，前端将两个数据合并后，再将index作为value
        this.goodsNameOptions = [...goodsPageOptions, ...goodsTypeOptions].map((item, index) => {
          return {
            ...item,
            value: index,
          }
        })
      }).catch((err) => {
        console.error('获取商品类型失败:', err)
        this.$message.error('获取商品类型失败')
      })
    },
    getMemberTypeId(memberType) {
      return memberType.map((item) => {
        const currentItem = this.memberTypeOptions.find((memberTypeItem) => item == memberTypeItem.value)
        return currentItem ? currentItem.id : ''
      }).join(',')
    },
    getGoodsTypeId(goodsIds) {
      console.log('goodsIds', goodsIds)
      return goodsIds.map((item) => {
        const currentItem = this.goodsNameOptions.find((goodsNameItem) => item == goodsNameItem.value)
        return currentItem ? currentItem.id : ''
      }).join(',')
    },
    // 打开重跑弹窗
    openRerunDialog() {
      this.rerunForm = {
        startMonth: this.searchForm.month ? this.searchForm.month.replace('-', '') : '',
        endMonth: this.searchForm.month ? this.searchForm.month.replace('-', '') : '',
        orderId: ''
      }
      this.rerunDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.rerunForm) {
          this.$refs.rerunForm.clearValidate()
        }
      })
    },
    // 提交重跑请求
    submitRerun() {
      this.$refs.rerunForm.validate(async (valid) => {
        if (!valid) return
        if (this.rerunForm.startMonth > this.rerunForm.endMonth) {
          this.$message.warning('开始月份不能大于结束月份')
          return
        }
        this.rerunLoading = true
        try {
          const params = {
            startMonth: this.rerunForm.startMonth,
            endMonth: this.rerunForm.endMonth,
          }
          if (this.rerunForm.orderId) {
            params.orderId = this.rerunForm.orderId
          }
          const { data } = await runForOperation(params)
          if (data.code === 200) {
            this.$message.success(data.data || '重跑任务已触发，后台正在跑数')
            this.rerunDialogVisible = false
            this.historyDialogVisible = true
            this.loadHistory()
            this.startPolling()
          } else {
            this.$message.error(data.message || '操作失败')
          }
        } catch (error) {
          console.error('重跑失败:', error)
          this.$message.error('重跑失败')
        } finally {
          this.rerunLoading = false
        }
      })
    },
    // 开始轮询任务状态
    startPolling() {
      this.stopPolling()
      this.pollingTimer = setInterval(() => {
        this.loadHistory()
      }, 10000)
    },
    // 停止轮询
    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    },
    // 历史弹窗关闭时停止轮询
    handleHistoryClose() {
      this.stopPolling()
    },
    // 打开历史弹窗
    openHistoryDialog() {
      this.historyDialogVisible = true
      this.loadHistory()
    },
    // 加载重跑历史
    async loadHistory() {
      this.historyLoading = true
      try {
        const { data } = await getTaskStatus()
        if (data.code === 200) {
          this.historyList = data.data || []
        } else {
          this.$message.error(data.message || '获取历史记录失败')
        }
      } catch (error) {
        console.error('获取历史记录失败:', error)
        this.$message.error('获取历史记录失败')
      } finally {
        this.historyLoading = false
      }
    },
    // 状态标签类型
    getStatusTagType(status) {
      const map = {
        '执行中': 'warning',
        '完成': 'success',
        '失败': 'danger'
      }
      return map[status] || 'info'
    },
    // 根据选项数组解析标签
    resolveOptionLabel(value, options) {
      const option = options.find(option => option.value == value)
      return option ? option.label : '-'
    }
  }
}
</script>

<style lang="scss" scoped>
.order-allocation-details {

  .pagination-container {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
    padding: 16px;
    background-color: #fff;
    border-radius: 4px;
  }
}
</style>
